<template>
  <div class="not-registered">
    <span class="kds-typography-paragraph-large">
      {{ $t('b2b_login_label_go_to_signup') }}
    </span>
    <a
      :href="`/${corporate.key}/login`"
      class="not-registered--link kds-color-text-interactive-accent kds-typography-title-medium"
      @click="redirectToSignUp"
    >
      {{ $t('b2b_login_action_go_to_signup') }}
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import useCorporateStore from '@shared/stores/useCorporateStore.js'

import ROUTE from '@us/app/router/appModule/names'

const corporateStore = useCorporateStore()
const router = useRouter()

const corporate = computed(() => corporateStore.corporate)

const redirectToSignUp = (event) => {
  if (event) {
    event.preventDefault()
  }
  router.push({
    name: ROUTE.SIGN_UP,
  })
}
</script>

<style lang="scss">
.not-registered {
  margin: auto;
  padding: $kds-space-1x 0;
  display: flex;
  gap: $kds-space-1x;
  align-items: baseline;

  @include media-up(lg) {
    padding-bottom: 0;
  }

  &--link {
    text-decoration: none;
  }
}
</style>
